import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format, formatISO } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const HealthInsurance: FC = () => {
  return (
    <Box mt={1}>
        <Header>
            <TextField
                label="Кем предоставлено жилье"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "800px" }}
            />
            <TextField
                label="Год предоставления жилья"
                value={format(1683886255004, "dd.MM.yyyy")}
                variant="outlined"
                size="small"
                sx={{ width: "200px", mb: 1 }}
            />
            <TextField
                label="Характеристика жилья"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "800px" }}
            />
            <Box display="flex" alignItems="center">
                <Typography mr={1}>Нуждается в жилье: </Typography>
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="да"
                />
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="нет"
                />
            </Box>
        </Header>
        <Body>

        </Body>
    </Box>
  );
};

export default HealthInsurance;
